// Auth
export const AUTH_LOGIN = 'login';
export const AUTH_LOGOUT = 'logout';
export const SET_USER_STATE = 'setUserState'
// Navigation
export const NAVIGATION_RESET_ALL = 'navigationResetAll';
export const NAVIGATION_SET_DRAWER = 'navigationSetDrawer';

// Pagination
export const PAGINATION_SET_ITEM_PER_PAGE = 'setPaginationItemPerPage';

// Snackbar
export const SNACKBAR_SHOW = 'snackbarShow';
export const SNACKBAR_HIDE = 'snackbarHide';

/* Loading module */
export const LOADING_SHOW = 'loadingShow';
export const LOADING_HIDE = 'loadingHide';
export const LOADING_REQUEST_INCREASE = 'loadingRequestIncrease';
export const LOADING_REQUEST_RELEASE = 'loadingRequestRelease';

// Confirm
export const CONFIRM_SHOW = 'confirmShow';
export const CONFIRM_OK = 'confirmOk';
export const CONFIRM_CANCEL = 'confirmCancel';
